import React, { memo } from "react";
import { useQuery } from "react-query";
import { getProducts } from "services/headwallServices";
import { PRODUCT } from "constants/appConstant";
import { useRightPanelStore, useHeadWallStore } from "store";

const models = {
  "Horizontal Infinity": "infinity",
  "Axiom Headwall": "axiom",
  "Array SSH Headwall": "array",
  "Compass Headwall": "compass",
  Console: "console",
  Eloquence: "eloquence",
  "Security Console": "security_console",
  "Hidden Headwall": "hidden",
};

function Product() {
  const {
    values,
    setValues,
    resetState: resetHeadwallData,
  } = useHeadWallStore();
  const { resetState } = useRightPanelStore();
  const { sub_model, name, model } = values;

  //  Queries
  const { data: products } = useQuery({
    queryKey: ["products"],
    queryFn: getProducts,
  });

  const handleProduct = (headwalltype) => {
    // Reset existing data
    resetHeadwallData();

    const baseHeadwall = {
      position: "",
      services: [],
      width: 0,
      color: "",
      background: "7953",
    };

    const baseValues = {
      model: headwalltype,
      name: name,
      width: { ft: 0, in: 0, ftError: "" },
      headwalls: [{ ...baseHeadwall }],
      add_rail: "",
    };

    switch (headwalltype) {
      case PRODUCT.INFINITY:
        baseValues.width.ft = 3;
        baseValues.headwalls[0].position = "middle";
        break;

      case PRODUCT.AXIOM:
        baseValues.width.ft = 2;
        baseValues.headwalls[0].position = "middle";
        baseValues.step = 2;
        break;

      case PRODUCT.COMPASS:
        baseValues.headwalls[0].width = 12;
        break;

      case PRODUCT.ARRAY:
        baseValues.headwalls[0].width = 2;
        break;

      case PRODUCT.CONSOLE:
        baseValues.width.in = 12;
        baseValues.step = 2;
        break;

      case PRODUCT.ELOQUENCE:
        baseValues.width.ft = 2;
        baseValues.width.in = 6;
        baseValues.headwalls = [
          { ...baseHeadwall, services: [] },
          { ...baseHeadwall, services: [] },
        ];
        baseValues.step = 2;
        break;

      case PRODUCT.SECURITY:
        switch (sub_model) {
          case "surface_monuted":
            baseValues.width.ft = 0;
            baseValues.width.in = 14.125;
            break;
          case "insight":
            baseValues.width.ft = 0;
            baseValues.width.in = 17.125;
            break;
          case "enclosure":
            baseValues.width.ft = 0; // or whatever value
            baseValues.width.in = 8; // or whatever value
            break;
          default:
            baseValues.width.in = 14.125; // fallback
        }
        baseValues.step = 2;
        // Override baseHeadwall color + background
        baseValues.headwalls = [
          {
            ...baseHeadwall,
            color: "#a5a5a5",
            background: "",
          },
        ];
        break;

      case PRODUCT.HIDDEN:
        switch (sub_model) {
          case "single":
            baseValues.width.in = 24;
            break;
          case "double":
            baseValues.width.in = 48;
            break;
          default:
            baseValues.width.in = 24; // fallback
        }
        // baseValues.width.in = 24;
        baseValues.width.ft = 0;
        baseValues.step = 2;
        baseValues.headwalls = [
          { ...baseHeadwall, services: [] },
          { ...baseHeadwall, services: [] },
          { ...baseHeadwall, services: [] },
        ];
        baseValues.add_rail = "right";
        break;

      default:
        // Optionally handle unknown product types
        break;
    }

    setValues(baseValues);
    resetState(); // Reset right panel
  };

  return (
    <div className="pt-4">
      <p className="font-bold text-base txtBlue">Headwall Style</p>
      <div className="overflow-auto newheight pr-4">
        <div className="grid grid-cols-1 gap-4 text-white mt-4 mb-4">
          {products?.data?.data.map((pro, i) => (
            <div
              key={i}
              className={`rounded-lg border-2 border-orange-600 overflow-hidden cursor-pointer hover:opacity-100 ${
                model === models[pro.name] || model === ""
                  ? "opacity-100"
                  : "opacity-50"
              }`}
              onClick={() => handleProduct(models[pro.name])}
            >
              <img
                draggable={false}
                src={pro.image_url}
                alt="..img"
                className="w-full"
              />
              <p className=" text-sm font-bold bg-white text-orange-600 p-4 flex justify-center">
                {pro.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(Product);
